import { io } from "socket.io-client";
import config from "../config"

let socket = null;

export const connectSocket = (userType, userId) => {
    console.log("⚡ connectSocket CALLED");

    if (!userId) {
        console.log("⛔ No userId, socket not connecting");
        return null;
    }

    if (socket) {
        console.log("🟡 Socket already exists");
        return socket;
    }

    console.log("🌐 Creating new socket connection...");

    socket = io(config.webSocketUrl, {
        transports: ["websocket"],
        reconnection: true,
    });

    socket.on("connect", () => {
        console.log("🟢 SOCKET CONNECTED:", socket.id);

        socket.emit("register", {
            user_type: userType,
            user_id: Number(userId),
        });

        console.log("📡 REGISTER EVENT SENT");

        // 🔥 LISTENER YAHI LAGAO
        socket.on("notification", (data) => {
            console.log("🔥 ADMIN RECEIVED:", data);
        });
    });

    socket.on("connect_error", (err) => {
        console.log("❌ CONNECT ERROR:", err.message);
    });

    socket.on("disconnect", (reason) => {
        console.log("🔴 SOCKET DISCONNECTED:", reason);
    });

    return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
    if (socket) {
        console.log("🛑 Disconnecting socket...");
        socket.disconnect();
        socket = null;
    }
};